import {
  createTheme,
  ThemeOptions,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import { appTheme } from "../helpers/constants";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    dark: Palette["primary"];
    light: Palette["primary"];
    normal: Palette["primary"];
    gradientDay: Palette["primary"];
    gradientNight: Palette["primary"];
    gradientMorning: Palette["primary"];
    gradientAfternoon: Palette["primary"];
    gradientEvening: Palette["primary"];
    activityMotion: Palette["primary"];
    contactBlue: Palette["primary"];
    paused: Palette["primary"];
    noData: Palette["primary"];
    metrics: Palette["primary"];
    indicator: Palette["primary"];
    gray: Palette["primary"];
    lightGrey: Palette["primary"];
    lightTransparent: Palette["primary"];
  }
  interface PaletteOptions {
    dark: PaletteOptions["primary"];
    light: PaletteOptions["primary"];
    normal: PaletteOptions["primary"];
    gradientDay: PaletteOptions["primary"];
    gradientNight: PaletteOptions["primary"];
    gradientMorning: PaletteOptions["primary"];
    gradientAfternoon: PaletteOptions["primary"];
    gradientEvening: PaletteOptions["primary"];
    contactBlue: PaletteOptions["primary"];
    activityMotion: PaletteOptions["primary"];
    paused: PaletteOptions["primary"];
    noData: PaletteOptions["primary"];
    metrics: PaletteOptions["primary"];
    indicator: PaletteOptions["primary"];
    gray: PaletteOptions["primary"];
    lightGrey: PaletteOptions["primary"];
    lightTransparent: PaletteOptions["primary"];
  }
}

declare module "@material-ui/core/styles/createTypography" {
  interface Typography {
    primaryFontFamily: string;
    secondaryFontFamily: string;
    tertiaryFontFamily: string;
  }
}

declare module "@material-ui/core/styles/createPalette" {
  interface PaletteColor {
    trans?: string;
    lightTrans?: string;
    anomaly?: string;
  }
}

export const getTheme = () => {
  return appTheme as ThemeOptions;
};

export default function createAppTheme() {
  return responsiveFontSizes(createTheme(getTheme()));
}
